var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfIconWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m100 50a50 50 0 1 1 -50-50 50 50 0 0 1 50 50zm-77.15-22.52a2.46 2.46 0 0 0 -.72 1.69v.52q0 16 0 32a1.33 1.33 0 0 1 -.34.94c-1.89 2.25-3.75 4.53-5.67 6.76a1.3 1.3 0 0 0 -.23 1.31 3.8 3.8 0 0 0 3.7 2.92h60.56a3.79 3.79 0 0 0 3.71-2.28 9.15 9.15 0 0 0 .33-1.05v-.49l-4.3-5.13c-.61-.73-1.22-1.46-1.81-2.2a1.09 1.09 0 0 1 -.22-.62q0-16.15 0-32.32a2.53 2.53 0 0 0 -1-2.22 7.09 7.09 0 0 0 -1.25-.56h-51.24a3.12 3.12 0 0 0 -1.52.73zm49.08 2.43a2.28 2.28 0 0 1 2.31 1.71 3.27 3.27 0 0 1 0 .54v25.45a2.21 2.21 0 0 1 -2.3 2.3h-43.94a2.22 2.22 0 0 1 -2.32-2.32c0-8.76 0-16.92 0-25.41a2.29 2.29 0 0 1 2.32-2.27h21.95s14.66.02 21.98 0zm-32.36 39.84c.63-.76 1.23-1.48 1.84-2.19a.45.45 0 0 1 .31-.1h16.53a.46.46 0 0 1 .33.12c.61.7 1.2 1.41 1.83 2.17zm15.19 1.3h.38a.59.59 0 0 1 .55.55.61.61 0 0 1 -.42.65.93.93 0 0 1 -.34.06h-9.87a1 1 0 0 1 -.46-.1.56.56 0 0 1 -.29-.65.57.57 0 0 1 .51-.5h9.94z",
    fill: "#f57c00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfIconWebsite);
export default __webpack_public_path__ + "static/media/bf-icon-website.cbab7be55c0b11b8a27590acd2c97639.svg";
export { ForwardRef as ReactComponent };